import { render, staticRenderFns } from "./CardApresentacao.vue?vue&type=template&id=9cab22a6&"
import script from "./CardApresentacao.vue?vue&type=script&lang=js&"
export * from "./CardApresentacao.vue?vue&type=script&lang=js&"
import style0 from "./CardApresentacao.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VImg } from 'vuetify/lib/components/VImg';
installComponents(component, {VCard,VCardTitle,VImg})
